import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
export default function Auth() {
  const [params] = useSearchParams();
  const [mode, setMode] = useState(params.get("mode") === "signup" ? "signup" : "login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const { login, signup } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = mode === "signup"
        ? await signup(email, password, name || email.split("@")[0])
        : await login(email, password);
      toast.success(mode === "signup" ? "Welcome to the herd." : "Good to see you.");
      nav(user.onboarded ? "/dashboard" : "/onboarding");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something snagged. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2" style={{ backgroundColor: "#F5F5F0" }} data-testid="auth-page">
      <div className="hidden md:flex relative flex-col justify-center items-stretch gap-10 p-10 grain" style={{ backgroundColor: "#030418" }}>
        <Link
          to="/"
          data-testid="auth-back-to-landing"
          className="self-center rounded-full font-bold uppercase tracking-widest transition-transform hover:scale-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 flex items-center"
          style={{
            backgroundColor: "#9bd5d7",
            color: "#0e203b",
            paddingInline: "clamp(24px, 3vw, 36px)",
            height: "clamp(29px, 3vw, 34px)",
            fontSize: "clamp(11px, 1.1vw, 13px)",
            letterSpacing: "0.2em",
            boxShadow: "0 10px 28px rgba(152, 216, 216, 0.45)",
          }}
        >
          ← Back to landing
        </Link>
        <video
          src="/mammoth_loop.mp4"
          autoPlay
          loop
          muted
          playsInline
          data-testid="auth-brand-video"
          className="w-full rounded-3xl block"
          style={{ backgroundColor: "#030418", aspectRatio: "16 / 9", objectFit: "cover" }}
        />
        <div className="font-display font-medium text-xl italic max-w-sm text-center self-center" style={{ color: "#9bd5d7" }}>"True strength is measured not by might, but by gentle, daily care."</div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-10">
        <form onSubmit={submit} className="w-full max-w-md bg-white rounded-3xl p-8 sm:p-10 shadow-xl border border-[#0e203b]/5 animate-fadeUp" data-testid="auth-form">
          <div className="font-display font-black text-3xl tracking-tight">{mode === "signup" ? "Join the herd" : "Welcome back"}</div>
          <p className="text-sm text-neutral-600 mt-1">{mode === "signup" ? "One account. One mammoth. Many quiet wins." : "Pick up where you left off."}</p>

          {mode === "signup" && (
            <input data-testid="auth-name" required value={name} onChange={e => setName(e.target.value)} placeholder="Your name" className="mt-6 w-full h-12 px-4 rounded-full border-2 border-[#0e203b]/10 focus:border-[#0e203b] outline-none font-medium" />
          )}
          <input data-testid="auth-email" required type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" className="mt-3 w-full h-12 px-4 rounded-full border-2 border-[#0e203b]/10 focus:border-[#0e203b] outline-none font-medium" />
          <input data-testid="auth-password" required type="password" minLength={6} value={password} onChange={e => setPassword(e.target.value)} placeholder="Password (min 6)" className="mt-3 w-full h-12 px-4 rounded-full border-2 border-[#0e203b]/10 focus:border-[#0e203b] outline-none font-medium" />

          <button disabled={busy} data-testid="auth-submit" className="btn-pill mt-6 w-full h-14 rounded-full bg-[#0e203b] text-white font-bold disabled:opacity-50">
            {busy ? "…" : mode === "signup" ? "Create account" : "Sign in"}
          </button>

          <button type="button" onClick={() => setMode(mode === "signup" ? "login" : "signup")} data-testid="auth-toggle" className="mt-4 w-full text-sm text-neutral-600 hover:text-[#0e203b]">
            {mode === "signup" ? "Already have an account? Sign in" : "New here? Create an account"}
          </button>
        </form>
      </div>
    </div>
  );
}
